import React from 'react';
import classNames from 'classnames/bind';
import { RichText } from '@components';
import { Typography } from 'gd-design-library';
import { ProductDetailsFormattedTextItem } from '@services';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsFormattedTextItem;
}

export const FormattedText: React.FC<Props> = ({
  productDetailsItem: {
    formatted_text: {
      title,
      text
    }
  }
}) => (
  <div className={ cx(productDetailsItemClassName) }>
    <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
      {title}
    </Typography>
    <RichText richText={ text } />
  </div>
);
